import { useState } from "react";
import { useParams } from "react-router";

import { AcquirerToVirtualEditForm } from "src/app/features/Acquirer/components/forms/AcquirerToVirtualEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { ResourceName, ResourceVariant } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const AcquirerToVirtualEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const { id } = useParams();

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersPhysicalToVirtualEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={false} onClick={triggerFormSubmit} />
                    <BackButton
                        isDisabled={false}
                        url={`${BASE_PATH}/${ResourceName.ACQUIRER}/${ResourceVariant.VIRTUAL}/${FORM_ACTION.EDIT}/${id}`}
                    />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AcquirerToVirtualEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
